import * as React from 'react'
import { CardHeader, Skeleton } from '@mui/material'

const CategoryLoader = () => (
  <CardHeader
    avatar={
      <Skeleton animation="wave" variant="circular" width={40} height={40} />
    }
    title={
      <Skeleton
        animation="wave"
        height={10}
        width="80%"
        style={{ marginBottom: 6 }}
      />
    }
  />
)

export default CategoryLoader
